"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOptionFromErr = exports.toOptionFromOk = void 0;
var Option_1 = require("../PlainOption/Option");
/**
 *  Convert to `Some(T)` if _input_ is `Ok(T)`.
 *  Otherwise, return `None`.
 */
function toOptionFromOk(input) {
    if (input.ok) {
        return (0, Option_1.createSome)(input.val);
    }
    return (0, Option_1.createNone)();
}
exports.toOptionFromOk = toOptionFromOk;
/**
 *  Convert to `Some(E)` if _input_ is `Err(E)`.
 *  Otherwise, return `None`.
 */
function toOptionFromErr(input) {
    if (!input.ok) {
        return (0, Option_1.createSome)(input.err);
    }
    return (0, Option_1.createNone)();
}
exports.toOptionFromErr = toOptionFromErr;
